/* eslint-disable */

function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

const highlight = (e, f, _cb) => {
    if(_cb && _cb()) return; // return true from a callback to prevent highlighting
    if(e.target == f) {
        preventDefaults(e);
        e.stopImmediatePropagation();
        if(!e.target.classList.contains('highlight')) {
            e.target.classList.add('highlight');
            _cb(e, 'highlight');

        }
    } else {
        // temporary... always highlight
        if(f && !f.classList.contains('highlight')) {
            f.classList.add('highlight');
            _cb(e, 'highlight2');

        }
    }
};

function unhighlight(e, f) {
    if(e.target && e.target.classList.contains('highlight')) {
        e.target.classList.remove('highlight');
    }
    if(f && f.classList.contains('highlight')) {
        f.classList.remove('highlight');
    }
}
function handleDrop(e, dropCallback) {
    if(dropCallback) dropCallback(e);
}

export const startDragAndDropForElement = (dropArea, dropCallback, moreCallback) => {
    const _cb = typeof moreCallback === 'function' ? moreCallback : function() {};
    if(Array.isArray(dropArea)) {
        dropArea.forEach(d => {
            handleDragDrop(d, dropCallback, true, _cb);
        });
    } else {
        handleDragDrop(dropArea, dropCallback, true, _cb);
    }
};

const stopDragAndDropForElement = dropArea => {
    handleDragDrop(dropArea, null, false);
};

const handleDragDrop = (dropArea, dropCallback, addListeners = true, _cb) => {
    const addFn = addListeners ? 'addEventListener' : 'removeEventListener';

    // Prevent default drag behaviors
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        // dropArea[addFn](eventName, (e) => preventDefaults(e, dropArea), false);
        dropArea[addFn](eventName, preventDefaults, false);
    });

    // Highlight drop area when item is dragged over it
    ['dragenter', 'dragover'].forEach(eventName => {
        // dropArea[addFn](eventName, highlight, true);
        dropArea[addFn](eventName, (e) => highlight(e, dropArea, _cb), false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
        dropArea[addFn](eventName, (e) => unhighlight(e, dropArea), false);
    });

    let handleDrop;

    if(addListeners) {
        handleDrop = dropCallback ? dropCallback : function() {};
        dropArea['dropCallback'] = handleDrop;
    } else {
        handleDrop = dropArea['dropCallback'] || function() {};
    }

    //Handle dropped files
    dropArea[addFn]('drop', handleDrop, false);
};
